<div nz-flex [nzVertical]="true" class="p-10">
  <nz-row nzGutter="24" class="rows">
    <nz-col nzSpan="22">
      <nz-list nzBordered nzSize="small">
  @for (item of timesheetData; track trackByFn(item)) {
          <nz-list-item
            (click)="showModal(item.code)"
            [class.disabled]="!item.isEnabled"
            class="hand-cursor"
            >
            {{ item.title }}
          </nz-list-item>
        }
      </nz-list>
    </nz-col>
  </nz-row>

  <!--Model for data export-->
  <nz-modal
    [(nzVisible)]="isVisible"
    [nzFooter]="null"
    (nzOnCancel)="handleCancel()"
    >
    <ng-container *nzModalContent>
      @if (showLoader) {
        <div class="loader-center mt-5">
          <mat-progress-spinner
            color="primary"
            mode="indeterminate"
            diameter="50"
          ></mat-progress-spinner>
          <span class="mt-4">{{ timesheetReport.downloadFileTxt }}</span>
        </div>
      }
      @if (!showLoader) {
        <div>
          <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()">
            <div nz-row>
              <div nz-col nzSpan="16">
                @for (item of formFields; track item) {
                  <nz-form-item>
                    <nz-form-label nzSpan="7">{{ item.name }}</nz-form-label>
                    <nz-form-control nzSpan="15">
                      <input
                        nz-input
                        type="{{ item.type }}"
                        formControlName="{{ item.formControlName }}"
                        />
                        @if (
                          validateForm
                          ?.get(item.formControlName)
                          ?.hasError('required') &&
                          validateForm.get(item.formControlName)?.touched
                          ) {
                          <div
                            class="pt-1 pb-2"
                            >
                            <b class="text-danger">Please enter {{ item.name }}</b>
                          </div>
                        }
                      </nz-form-control>
                    </nz-form-item>
                  }
                </div>
                <div nz-col nzSpan="8">
                  <h4 class="text-left">{{ timesheetReport.status }}:</h4>
                  <label>
                    <input
                      type="checkbox"
                      formControlName="selectAll"
                      (change)="toggleSelectAll($event)"
                      />
                      {{ timesheetReport.selectAll }}
                    </label>
                    <hr />
                    @if (showStatusLoader) {
                      <div class="item-center mt-5">
                        <mat-progress-spinner
                          color="primary"
                          mode="indeterminate"
                          diameter="50"
                        ></mat-progress-spinner>
                      </div>
                    }
                    @if (!showStatusLoader) {
                      <div formArrayName="category">
                        @for (item of category.controls; track item; let i = $index) {
                          <div
                            [formGroupName]="i"
                            >
                            <label>
                              <input
                                type="checkbox"
                                formControlName="selected"
                                (change)="onCheckboxChange()"
                                />
                                {{ item.get("name")?.value }}
                              </label>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div nz-row class="mt-3">
                    <div nz-col nzSpan="12" nzOffset="6">
                      <button
                        nz-button
                        nzType="primary"
                        type="submit"
                        value="Send"
                        class="minus-margin"
                        nzBlock
                        >
                        {{ timesheetReport.exportXLS }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            }
          </ng-container>
        </nz-modal>
      </div>
